module.exports = __webpack_public_path__ + "static/media/An Intuitive Case for Jesus Dire Words.6d838d7b.docx";